// @flow

import type {
  MarkdocNodeRegistration,
  MarkdocTagRegistration,
} from 'docs/markdoc';

// This is a node, which corresponds to Markdown backticks
export const InlineCodeNode: MarkdocNodeRegistration = {
  node: 'code',
  component: 'InlineCode',
  attributes: {
    content: {type: String, required: true},
  },
};

export const InlineCodeTag: MarkdocTagRegistration = {
  tag: 'code',
  component: 'InlineCode',
  attributes: {
    copyable: {
      type: Boolean,
      default: false,
      description:
        'If true, a copy icon is shown next to the text which allows user to quickly copy the content to their clipboard.',
    },
  },
};
